/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */



export const COVERAGE_REQUIREMENTS_SLICE_NAME = "COVERAGE_REQUIREMENTS";
export type COVERAGE_REQUIREMENTS_SLICE_NAME = typeof COVERAGE_REQUIREMENTS_SLICE_NAME;


export const GET_REDLINE_DATA = `${COVERAGE_REQUIREMENTS_SLICE_NAME}/getRedlineData`; // must be same as name of reducer action
export type GET_REDLINE_DATA = typeof GET_REDLINE_DATA;